import { render, staticRenderFns } from "./CustChange.vue?vue&type=template&id=2deff07a"
import script from "./CustChange.vue?vue&type=script&lang=js"
export * from "./CustChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports